import { render, staticRenderFns } from "./SuratJalan2.vue?vue&type=template&id=bf488344&scoped=true&"
import script from "./SuratJalan2.vue?vue&type=script&lang=js&"
export * from "./SuratJalan2.vue?vue&type=script&lang=js&"
import style0 from "./SuratJalan2.vue?vue&type=style&index=0&id=bf488344&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf488344",
  null
  
)

export default component.exports